var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.$t('chat.filterRead')},model:{value:(_vm.readFilter),callback:function ($$v) {_vm.readFilter=$$v},expression:"readFilter"}})}
var staticRenderFns = []

export { render, staticRenderFns }